(() => {
  const selector = '[data-map-passport]';
  if (window.__littlegPassportBoot) { window.__littlegPassportBoot(document); return; }

  const isChinese = () => (
    document.documentElement.lang
      .toLowerCase()
      .startsWith('zh')
  );

  const text = (zh, en) => (
    isChinese() ? zh : en
  );

  const safeCount = (value) => {
    const number = Number(value);

    return Number.isFinite(number) && number >= 0
      ? number
      : 0;
  };

  const safeYear = (value, fallback) => (
    /^\d{4}$/.test(String(value))
      ? String(value)
      : fallback
  );

  const MEMORY_VIEWS = Object.freeze([
    'friends',
    'alumni',
    'class',
    'family',
    'travel',
    'growth'
  ]);

  const safeMemoryView = (value) => {
    const view = String(value || '')
      .trim()
      .toLowerCase();

    return MEMORY_VIEWS.includes(view)
      ? view
      : '';
  };

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const mount = (root) => {
    if (root.__passportCleanup) return;
    const controller = new AbortController();
    const listen = (node, type, handler) => node.addEventListener(type, handler, { signal: controller.signal });
    let timer;
    root.__passportCleanup = () => { root.querySelector('[data-passport-event-sheet]')?.close(); controller.abort(); window.clearTimeout(timer); root.__passportCleanup = null; };
    const sheet = root.querySelector('[data-passport-event-sheet]');
    let detailTrigger = null;
    const closeDetail = () => { if (sheet?.open) sheet.close(); if (sheet) sheet.querySelectorAll('[data-passport-event-title], [data-passport-event-date], [data-passport-event-source], [data-passport-event-description]').forEach(node => { node.textContent = ''; }); };
    const showDetail = (id, trigger) => {
      const snapshot = window.LittleGFamilyData?.livingCvSnapshot?.();
      const event = snapshot?.records?.find(record => record.id === id);
      if (!event || !sheet || snapshot.status !== 'ready') { closeDetail(); return; }
      sheet.querySelector('[data-passport-event-title]').textContent = event.title || text('生活事件', 'Life event');
      sheet.querySelector('[data-passport-event-date]').textContent = event.saved_at;
      sheet.querySelector('[data-passport-event-source]').textContent = event.source_type + ' · ' + event.persistence_status;
      sheet.querySelector('[data-passport-event-description]').textContent = event.description || '';
      sheet.dataset.eventId = event.id; detailTrigger = trigger; sheet.showModal();
    };
    if (sheet) {
      listen(sheet.querySelector('[data-kid-memory-view-close]'), 'click', closeDetail);
      listen(sheet, 'close', () => { sheet.querySelectorAll('[data-passport-event-title], [data-passport-event-date], [data-passport-event-source], [data-passport-event-description]').forEach(node => { node.textContent = ''; }); sheet.removeAttribute('data-event-id'); if (detailTrigger?.isConnected && !detailTrigger.closest('[hidden], [inert]')) detailTrigger.focus({ preventScroll: true }); });
    }
    const now = safeYear(
      root.dataset.currentYear,
      String(new Date().getFullYear())
    );

    const loading = root.querySelector(
      '[data-passport-loading]'
    );

    const content = root.querySelector(
      '[data-passport-content]'
    );

    const yearPanel = root.querySelector(
      '[data-passport-year-panel]'
    );

    const events = root.querySelector(
      '[data-passport-events]'
    );

    const empty = root.querySelector(
      '[data-passport-empty]'
    );

    const status = root.querySelector(
      '[data-passport-status]'
    );

    const yearHeading = root.querySelector(
      '[data-passport-year-heading]'
    );

    const nowButton = root.querySelector(
      '[data-passport-now]'
    );

    let yearCards = [
      ...root.querySelectorAll(
        '[data-passport-year-card]'
      )
    ];

    let yearButtons = [
      ...root.querySelectorAll(
        '[data-passport-year]'
      )
    ];

    let cardYears = yearCards
      .map((card) => card.dataset.passportYearCard)
      .filter((year) => /^\d{4}$/.test(year));

    const params = new URLSearchParams(
      window.location.search
    );

    const requestedYear = safeYear(
      params.get('year'),
      now
    );

    // Preserve a valid deep-linked year until the private year projection arrives.
    // The initial HTML contains only the current year; it is not the source of truth.
    let selectedYear = requestedYear;

    let passportData = {
      years: [],
      records: {}
    };

    let hasResponse = false;

    const syncYears = () => {
      const years = [...new Set([now, ...(passportData.years || [])].map(String).filter(value => /^\d{4}$/.test(value)))].sort().reverse();
      const rail = root.querySelector('[data-passport-year-cards]');
      const template = root.querySelector('[data-passport-year-template]');
      if (!rail || !template) return;
      const focusedYear = document.activeElement?.dataset?.passportYear;
      rail.replaceChildren(...years.map(year => {
        const card = template.content.firstElementChild.cloneNode(true);
        card.dataset.passportYearCard = year; card.dataset.memoryYear = year;
        const button = card.querySelector('[data-passport-year]'); button.dataset.passportYear = year;
        const title = card.querySelector('.passport-year-card__year');
        title.id = title.id.replace(/\d{4}$/, year); title.textContent = year; button.setAttribute('aria-labelledby', title.id);
        const holder = document.createElement('div'); holder.setAttribute('role', 'listitem'); holder.append(card); return holder;
      }));
      yearCards = [...rail.querySelectorAll('[data-passport-year-card]')];
      yearButtons = [...rail.querySelectorAll('[data-passport-year]')]; cardYears = years;
      if (!cardYears.includes(selectedYear)) {
        selectedYear = now;
        replaceUrl(now);
      }
      if (focusedYear) yearButtons.find(button => button.dataset.passportYear === focusedYear)?.focus({ preventScroll: true });
    };
    const getRecord = (year) => {
      const records = passportData.records;

      if (
        !records ||
        typeof records !== 'object' ||
        Array.isArray(records)
      ) {
        return {};
      }

      const record = records[year];

      return record &&
        typeof record === 'object' &&
        !Array.isArray(record)
        ? record
        : {};
    };

    const getSummary = (year) => {
      const record = getRecord(year);
      const summary = record.summary;

      return summary &&
        typeof summary === 'object' &&
        !Array.isArray(summary)
        ? summary
        : {};
    };

    const updateUrl = (year) => {
      const url = new URL(
        window.location.href
      );

      if (year === now) {
        url.searchParams.delete('year');
      } else {
        url.searchParams.set('year', year);
      }

      window.history.pushState(
        {
          mapPassportYear: year
        },
        '',
        url
      );
    };

    const replaceUrl = (year) => {
      const url = new URL(
        window.location.href
      );

      if (year === now) {
        url.searchParams.delete('year');
      } else {
        url.searchParams.set('year', year);
      }

      window.history.replaceState(
        {
          mapPassportYear: year
        },
        '',
        url
      );
    };

    const updateYearCards = () => {
      yearCards.forEach((card) => {
        const year =
          card.dataset.passportYearCard;

        const isSelected =
          year === selectedYear;

        card.classList.toggle(
          'is-selected',
          isSelected
        );

        const button = card.querySelector(
          '[data-passport-year]'
        );

        if (button) {
          button.setAttribute(
            'aria-current',
            String(isSelected)
          );

          button.setAttribute(
            'aria-expanded',
            String(isSelected)
          );
        }

        const actionLabel = card.querySelector(
          '[data-passport-card-action-label]'
        );

        if (actionLabel) {
          actionLabel.textContent = isSelected
            ? text(
                '正在查看',
                'Viewing this year'
              )
            : text(
                '查看這一年',
                'View this year'
              );
        }
      });
    };

    const updateYearCardData = () => {
      yearCards.forEach((card) => {
        const year =
          card.dataset.passportYearCard;

        const summary = getSummary(year);

       const values = {
          friends: safeCount(
            summary.friends
          ),

          alumni: safeCount(
            summary.alumni
          ),

          class: summary.classLabel ||
            safeCount(summary.classes),

          travel: safeCount(
            summary.travel
          ),

          family: safeCount(
            summary.family
          ),

          growth: safeCount(
            summary.growth
          )
        };

        Object.entries(values).forEach(
          ([key, value]) => {
            const target = card.querySelector(
              `[data-passport-card-stat="${key}"]`
            );

            if (target) {
              target.textContent = value;
            }
          }
        );
      });
    };

     const createEventRow = (item) => {
      const row = document.createElement('li');

      row.className =
        'map-passport__event';

      const memoryView = safeMemoryView(
        item.memoryView || item.view
      );

      if (memoryView) {
        row.dataset.memoryView =
          memoryView;
      }

      if (item.id) {
        row.dataset.memoryId =
          String(item.id);
      }

      // Keep the timeline text-first. Record data must not dictate decorative emoji.
      const copy = document.createElement(
        'div'
      );

      const title = document.createElement(
        'h3'
      );

      const fallbackTitles = {
        friends: text('朋友回憶', 'Friend memory'),
        alumni: text('校友回憶', 'Alumni memory'),
        class: text('班級回憶', 'Class memory'),
        family: text('家庭回憶', 'Family memory'),
        travel: text('旅行回憶', 'Travel memory'),
        growth: text('成長回憶', 'Growth memory')
      };

      title.textContent = String(
        item.title ||
        fallbackTitles[memoryView] ||
        text('城市回憶', 'City memory')
      );

      copy.append(title);

      if (item.description) {
        const description =
          document.createElement('p');

        description.textContent = String(
          item.description
        );

        copy.append(description);
      }

      if (item.date) {
        const date = document.createElement(
          'time'
        );

        date.dateTime = String(
          item.date
        );

        date.textContent = String(
          item.dateLabel || item.date
        );

        copy.append(date);
      }

      const action = document.createElement('button'); action.type = 'button';
      action.dataset.passportEventId = String(item.id || '');
      action.textContent = text('查看詳情', 'View details');
      action.disabled = !item.id;
      copy.append(action);
      const provenance = document.createElement('small'); provenance.textContent = String(item.source_type || 'family-memory');
      copy.append(provenance);
      row.append(copy);

      return row;
    };

    const renderRecord = () => {
      const record = getRecord(
        selectedYear
      );

      const summary = getSummary(
        selectedYear
      );

      if (yearHeading) {
        yearHeading.textContent =
          selectedYear;
      }

       const summaryValues = {
        friends: safeCount(
          summary.friends
        ),

        alumni: safeCount(
          summary.alumni
        ),

        classes: safeCount(
          summary.classes
        ),

        travel: safeCount(
          summary.travel
        ),

        family: safeCount(
          summary.family
        ),

        growth: safeCount(
          summary.growth
        )
      };

      Object.entries(summaryValues).forEach(
        ([key, value]) => {
          const target = root.querySelector(
            `[data-passport-stat="${key}"]`
          );

          if (target) {
            target.textContent = value;
          }
        }
      );

      const recordEvents = Array.isArray(
        record.events
      )
        ? record.events
        : [];

     if (events) {
        events.dataset.passportYear =
          selectedYear;

        events.replaceChildren(
          ...recordEvents.map(
            createEventRow
          )
        );

        events.hidden =
          recordEvents.length === 0;
      }

      if (empty) {
        empty.hidden = passportData.status === 'unavailable' || recordEvents.length > 0;
      }

      if (nowButton) {
        nowButton.hidden =
          selectedYear === now;
      }

      if (status) {
        status.textContent = passportData.status === 'unavailable' ? text('記錄暫時無法讀取；數字 0 不代表已確認沒有記錄。', 'Records unavailable; zero does not mean verified empty.') : text(
          `正在查看 ${selectedYear} 年的成長歷程`,
          `Showing ${selectedYear} in your Living CV timeline`
        );
      }
    };

    const scrollSelectedCard = () => {
      // The responsive timeline is not a carousel. Avoid scrolling the entire
      // Dashboard page while hydrating or changing a selected year.
      if (!root.getClientRects().length) return;
      const rail = root.querySelector('[data-passport-year-cards]');
      if (!rail || rail.scrollWidth <= rail.clientWidth + 1) return;
      const selectedButton = root.querySelector(
        `[data-passport-year="${CSS.escape(selectedYear)}"]`
      );
      if (!selectedButton) return;
      const selectedRect = selectedButton.getBoundingClientRect();
      const railRect = rail.getBoundingClientRect();
      const delta = (selectedRect.left + selectedRect.right -
        railRect.left - railRect.right) / 2;
      rail.scrollBy({
        left: delta,
        behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
      });
    };

    const render = () => {
      updateYearCards();
      updateYearCardData();
      renderRecord();
    };

    const selectYear = (
      year,
      {
        pushHistory = true,
        focusPanel = false
      } = {}
    ) => {
      const safeSelectedYear = safeYear(
        year,
        selectedYear
      );

      if (!cardYears.includes(safeSelectedYear)) {
        return;
      }

      const yearChanged =
        safeSelectedYear !== selectedYear;

      selectedYear = safeSelectedYear;

      render();

      if (pushHistory && yearChanged) {
        updateUrl(selectedYear);
      }

      scrollSelectedCard();

      if (focusPanel && yearPanel) {
        yearPanel.focus({
          preventScroll: true
        });

        yearPanel.scrollIntoView({
          behavior: prefersReducedMotion.matches
            ? 'auto'
            : 'smooth',
          block: 'start'
        });
      }

      root.dispatchEvent(
        new CustomEvent(
          'littleg:map-passport-year-change',
          {
            bubbles: true,
            detail: {
              year: selectedYear
            }
          }
        )
      );
    };

    const reveal = () => {
      if (loading) {
        loading.hidden = true;
      }

      if (content) {
        content.hidden = false;
      }

      render();
    };

    listen(root,
      'click',
      (event) => {
        const eventButton = event.target.closest('[data-passport-event-id]');
        if (eventButton) { showDetail(eventButton.dataset.passportEventId, eventButton); return; }
        const yearButton =
          event.target.closest(
            '[data-passport-year]'
          );

        if (yearButton) {
          selectYear(
            yearButton.dataset.passportYear,
            {
              pushHistory: true,
              focusPanel: false
            }
          );

          return;
        }

        if (
          event.target.closest(
            '[data-passport-now]'
          )
        ) {
          selectYear(
            now,
            {
              pushHistory: true,
              focusPanel: false
            }
          );
        }
      }
    );

    listen(root,
      'keydown',
      (event) => {
        const button = event.target.closest(
          '[data-passport-year]'
        );

        if (
          !button ||
          ![
            'ArrowLeft',
            'ArrowRight',
            'Home',
            'End'
          ].includes(event.key)
        ) {
          return;
        }

        const index =
          yearButtons.indexOf(button);

        if (index < 0) return;

        event.preventDefault();

        let target;

        if (event.key === 'Home') {
          target = yearButtons[0];
        } else if (event.key === 'End') {
          target =
            yearButtons[
              yearButtons.length - 1
            ];
        } else {
          const direction =
            event.key === 'ArrowRight'
              ? 1
              : -1;

          const nextIndex =
            (
              index +
              direction +
              yearButtons.length
            ) % yearButtons.length;

          target =
            yearButtons[nextIndex];
        }

        target?.focus();
      }
    );

    listen(window,
      'popstate',
      () => {
        const urlYear = safeYear(
          new URLSearchParams(
            window.location.search
          ).get('year'),
          now
        );

        selectedYear = cardYears.includes(
          urlYear
        )
          ? urlYear
          : (
              cardYears.includes(now)
                ? now
                : cardYears[0] || now
            );

        render();
        scrollSelectedCard();
      }
    );

    listen(root,
      'littleg:map-passport-data',
      (event) => {
        hasResponse = true;

        passportData =
          event.detail &&
          typeof event.detail === 'object' &&
          !Array.isArray(event.detail)
            ? event.detail
            : passportData;

        syncYears();
        root.dataset.passportState = passportData.status || 'ready';
        reveal();
      }
    );

    if (
      requestedYear !== selectedYear
    ) {
      replaceUrl(selectedYear);
    }

    const request = () => root.dispatchEvent(new CustomEvent('littleg:map-passport-request', { bubbles: true, detail: { year: selectedYear } }));
    for (const name of ['littleg:cv-change', 'littleg:web-session-change', 'littleg:family-social-graph-change', 'littleg:family-cloud-sync', 'littleg:parent-gate-change', 'littleg:family-record-saved']) {
      listen(document, name, () => { closeDetail(); if (events) events.replaceChildren(); passportData = { status: 'unavailable', years: [], records: {} }; render(); request(); });
    }
    for (const name of ['littleg:city-mission:result-saved', 'littleg:city-mission:result-removed', 'littleg:city-mission:results-cleared']) listen(window, name, () => { closeDetail(); request(); });
    request();

    timer = window.setTimeout(() => {
      if (!hasResponse) {
        passportData.status = 'unavailable'; root.dataset.passportState = 'unavailable';
        reveal();
        if (status) {
          status.textContent = text(
            '暫時無法讀取成長歷程，請重新整理頁面再試。',
            'Timeline records are temporarily unavailable. Refresh to try again.'
          );
        }
        if (empty) empty.hidden = true;
      }
    }, 1200);
  };
  const boot = scope => { if (scope.matches?.(selector)) mount(scope); scope.querySelectorAll(selector).forEach(mount); };
  window.__littlegPassportBoot = boot;
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => { if (event.target.matches?.(selector)) event.target.__passportCleanup?.(); event.target.querySelectorAll(selector).forEach(root => root.__passportCleanup?.()); });
  boot(document);
})();
